export default __webpack_public_path__ + "static/media/kilit.8cd79867.png";